import { LazySvgIcon } from "components/UI/icon";
import Logo from "./Logo";
import Timer from "./Timer";

const RatingSubmitted = ({ data, setRatingPage }) => {
  const backToRatingPage = () => {
    setRatingPage(true);
  };
  return (
    <>
      <Logo />
      <div className="text-center pt-2">
        <h3 className="font-bold text-2xl tracking-wide">
          Terima kasih Anda Telah Memberikan Rating!
        </h3>
      </div>
      <div className="mt-8">
        <LazySvgIcon name={"thankyou"} />
      </div>
      <div>
        <p className="text-center mt-7 tracking-wide ">
          Kami sangat terbantu dengan peran serta <br /> Anda membuat layanan
          kami lebih baik
        </p>
      </div>
      {data && !data.expired && (
        <Timer time={data.remaining_minutes} action={backToRatingPage} />
      )}
    </>
  );
};

export default RatingSubmitted;
